import {
    SearchKeyConfig,
    UnifiedFilterConfig,
    UnifiedFilterModule,
} from '@core/modules/filters/unified-filter.module'
import { getTeamMemberDisplayName } from './team.utils'

export const teamSearchKeys: SearchKeyConfig[] = [
    { value: 'name', threshold: 0.3 },
    { value: 'first_name', threshold: 0.3 },
    { value: 'last_name', threshold: 0.3 },
    { value: 'email', threshold: 0.3 },
    { value: 'role', threshold: 0.2 },
]

const config = {
    mfa_status: {
        accessor: 'mfa_status',
        label: 'MFA',
        collapsible: true,
        filters: {
            Enabled: {
                id: 'Enabled',
                accessor: 'mfa_status',
                label: 'Enabled',
            },
            Disabled: {
                id: 'Disabled',
                accessor: 'mfa_status',
                label: 'Disabled',
            },
        },
    },
    alerts_status: {
        accessor: 'alerts_status',
        label: 'Email Alerts',
        collapsible: true,
        filters: {
            On: { id: 'On', accessor: 'alerts_status', label: 'On' },
            Off: { id: 'Off', accessor: 'alerts_status', label: 'Off' },
        },
    },
}

const defaultFilters = {
    mfa_status: { Enabled: false, Disabled: false },
    alerts_status: { On: false, Off: false },
}

const unifiedTeamConfig: UnifiedFilterConfig = {
    config,
    defaultFilters,
    searchKeys: teamSearchKeys,
    dataTransformer: (data: TTeamMember[]) =>
        data.map((member) => ({
            ...member,
            name: getTeamMemberDisplayName(member),
            mfa_status: member.mfa_active ? 'Enabled' : 'Disabled',
            alerts_status: member.send_alerts ? 'On' : 'Off',
        })),
    sortStrategy: (a: TTeamMember, b: TTeamMember) =>
        getTeamMemberDisplayName(a).localeCompare(getTeamMemberDisplayName(b)),
}

export const unifiedTeamFilterModule = new UnifiedFilterModule(
    unifiedTeamConfig,
    'team.unified.filter'
)
